import { createContext, useContext, useEffect } from "@wordpress/element";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import { useDispatch, useSelector } from "react-redux";
import { login } from "store/vino/storeSlice";
import { findCart } from "store/vino/cartSlice";
import { getSettings } from "store/settings/storeSlice";

export const AppContext = createContext({});
export const useAppContext = () => useContext(AppContext);

export const AppContextProvider = ({ children }) => {
	const dispatch = useDispatch();
	const customerToken = useSelector(({ vino }) => vino.cart.customerToken);
	const store = useSelector(({ vino }) => vino.store);
	const settings = useSelector(({ settings }) => settings.store);
	const contextValue = {
		customerToken,
	};

	useEffect(() => {
		if (store.isAuthenticated) {
			dispatch(findCart(customerToken));
		}
	}, [dispatch, customerToken, store]);

	useEffect(() => {
		dispatch(getSettings());
	}, [dispatch]);

	useEffect(() => {
		if (settings && settings.app_key) {
			dispatch(login(settings.app_key));
		}
	}, [dispatch, settings]);

	return (
		<AppContext.Provider value={contextValue}>
			{settings.isSettingsLoading && <LinearProgress />}
			{store.isAuthenticating && <LinearProgress />}
			{store.isAuthenticated && children}
			{/* {!store.isAuthenticated && !store.isAuthenticating && (
				<div>Configure</div>
			)} */}
		</AppContext.Provider>
	);
};

AppContextProvider.propTypes = {
	children: PropTypes.node,
};
